import React, { Component } from "react";
import {Row, Col, container, Table} from "react-bootstrap";
import ReactPlayer from "react-player";
import './audioplay.css';


import ExternalLayout from "../../../customComponents/ExternalLayout/ExternalLayout";
import RenderPage from "../../../customComponents/RenderPage/RenderPage";
import Strip from "../../../customComponents/Strip/Strip";
import { useWindowSize } from "@react-hook/window-size";
import SEOComponent from "../../../customComponents/SEO/SEOComponent";
import PropTypes from "prop-types";


// import Male Audio Samples
import audiom1 from "../../../assets/sampleDatasets/MarathiMale/marathi_agri_m.wav";
import audiom2 from "../../../assets/sampleDatasets/MarathiMale/marathi_edu_m.wav";
import audiom3 from "../../../assets/sampleDatasets/MarathiMale/marathi_finan_m.wav";


function Marathi_Male(){
    return( 
    <div className="container">
        <table>
            {/* Table Heading */}
            <thead className="headTable">
            <tr>
                <th className="headTable">Audio</th>
                <th className="headTable">Text</th>
            </tr>
            </thead>
            <tbody>
            <tr> {/* Table Row Sample 1 */}
                <td className="tableEvenRow"><ReactPlayer   
                        url={audiom1}
                        width="400px"
                        height="50px"
                        playing={false}
                        controls={true}
                        type = 'audio/mp3'
                    />
                </td>
                <td className="tableEvenRow"><p className="p-medium-line-spacing">भात आणि ऊस ही पिके देशातील निम्म्याहून अधिक सिंचनाचे पाणी गिळंकृत करतात.</p></td>
            </tr>
            <tr> {/* Table Row Sample 2 */}
                    <td className="tableOddRow"><ReactPlayer   
                        url={audiom2}
                        width="400px"
                        height="50px"
                        playing={false}
                        controls={true}
                        type = 'audio/mp3'
                    />
                </td>
                <td className="tableOddRow"><p className="p-medium-line-spacing">वृत्तसंस्था सिडनी इंडियन प्रिमियर लीगच्या अलीकडेच झालेल्या लिलावात मुंबई इंडियन्सने खरेदी केलेला ऑस्ट्रेलियाचा धडाकेबाज फलंदाज ख्रिस लीनने बिग बॅश लीगमधील सामन्यात जबरदस्त फटकेबाजी केली</p></td>
            </tr>
            <tr> {/* Table Row Sample 3 */}
                    <td className="tableEvenRow"><ReactPlayer   
                        url={audiom3}
                        width="400px"
                        height="50px"
                        playing={false}
                        controls={true}
                        type = 'audio/mp3'
                    />
                </td>
                <td className="tableEvenRow"><p className="p-medium-line-spacing">नाशिक विभागातील पाचही जिल्हाधिकारी कार्यालयांना एप्रिल २०१९ ते मार्च २०२० या आर्थिक वर्षासाठी ५४० कोटी १८ लाख ४७ हजार रुपये महसूल वसुलीचे उद्दिष्ट देण्यात आले आहे.</p></td>
            </tr>
            </tbody>

           
            
        </table>


    </div>

    );
}

const Sample_Marathi_Male = (props) => {
    const [width] = useWindowSize();

    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    return(
        <ExternalLayout>
            <RenderPage
                id="tst-landing"
                className={`render px-0 ${props.isClassName ? 'render-page ' : 'min-height-auto'}`}
                containerType="container-fluid"
            > 
                <SEOComponent
                    title="SampleMarathiMale"
                    keywords="Speech Recognition, respin, SPIRE LAB, Navana"
                    description="Speech recognition in agriculture and finance for the poor is an initiative predominantly to create resources and make them available as a digital public good"
                    siteUrl="/SampleMarathiMale" />
                   
                    <Strip
                        id="tst-SampleDatasets"
                        className="strip strip-no-padding px-20"
                        containerType="container"
                    >
                   

                    <div className="mx-0  pt-5">  
                        <h5 className="h5-medium section-title jostRegular title-navy-blue align-left pt-5 pb-5 line-height-48px pl-3"> Sample Marathi Male Audio</h5>
                            <div className="mx-0 mb-5 pb-5">
                                <Marathi_Male />
                            </div>
                    </div>

</Strip>
</RenderPage>
</ExternalLayout>
);
};

export default Sample_Marathi_Male;